import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

const PrevNext = ({ pageNumber, allPages, changePage }) => {
  return (
    <div className="flex items-center justify-center bg-base-200 rounded-lg flex-1">
      <div className="flex items-center space-x-2">
        <button
          onClick={() => changePage(-1)}
          disabled={pageNumber <= 1}
          className={`p-1 rounded-lg ${
            pageNumber <= 1
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
        >
          <ChevronLeftIcon className="h-5 w-5" />
        </button>
        <span className="text-xs font-medium">
          {pageNumber} of {allPages || 1}
        </span>
        <button
          onClick={() => changePage(1)}
          disabled={pageNumber >= (allPages || 1)}
          className={`p-1 rounded-lg ${
            pageNumber >= (allPages || 1)
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
        >
          <ChevronRightIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default PrevNext;
